import { requestEnvelope } from './client'
import { realtimeStatsSchema, type RealtimeStats } from './schemas'

export async function getRealtimeStats(): Promise<RealtimeStats> {
  return requestEnvelope('/stats/realtime', realtimeStatsSchema)
}
